import { render, staticRenderFns } from "./TotalStudentsProgress.vue?vue&type=template&id=f6a1674e"
import script from "./TotalStudentsProgress.vue?vue&type=script&lang=js"
export * from "./TotalStudentsProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports